import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ExpandableTagsBox from "./ExpandableTagsBox";
import { Edit, Save } from "@mui/icons-material";

export const InformationSnippet = ({
  title,
  value,
  valueComponent,
  useTagBox,
  allowAddTags,
  onAddTagsClicked,
  EditableComponent,
  onSave,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);
  const valuesArray = Array.isArray(value) ? value : [value];

  const handleClick = async () => {
    if (isEditing && onSave) {
      await onSave(tempValue);
    }
    setIsEditing((prev) => !prev);
  };

  const handleChange = (newValue) => {
    setTempValue(newValue);
  };

  return (
    <Card
      sx={{
        backgroundColor: "background.default",
        height: "100%",
      }}
      data-testid={`snippet-${title}`}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          variant="overline"
          color="text.secondary"
          sx={{ fontWeight: 700, letterSpacing: "0.08em" }}
          gutterBottom
        >
          {title}
        </Typography>
        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems={{ xs: "flex-start", md: "center" }}
          justifyContent="space-between"
          spacing={1}
        >
          {isEditing ? (
            <EditableComponent value={tempValue} onChange={handleChange} />
          ) : valueComponent ? (
            valueComponent
          ) : (
            <>
              {valuesArray.length === 1 &&
              (typeof valuesArray[0] === "string" ||
                typeof valuesArray[0] === "number") ? (
                <Typography
                  variant="subtitle1"
                  color="text.primary"
                  fontWeight={600}
                  gutterBottom
                >
                  {valuesArray[0]}
                </Typography>
              ) : useTagBox ? (
                <ExpandableTagsBox
                  tags={valuesArray}
                  excludeTitle
                  allowAddTags={allowAddTags}
                  onAddClicked={onAddTagsClicked}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  {valuesArray.map((v, index) => (
                    <Chip
                      key={index}
                      label={typeof v === "string" ? v : v.tag}
                    />
                  ))}
                </Box>
              )}
            </>
          )}
          {EditableComponent && (
            <Button
              variant="text"
              onClick={handleClick}
              startIcon={isEditing ? <Save /> : <Edit />}
              sx={{ p: 0, minWidth: "auto" }}
            >
              {isEditing ? "Save" : "Edit"}
            </Button>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
